import { xenvActionFactory } from '../xenv';
import { alimpLogin, alimpIsLogin, alimpSetLoginConfig, alipayLogin, alipayLogout, alipayIsLogin, alipaySetLoginConfig, alipayLoginCheckPhone, 
// bdmpLogin, bdmpIsLogin,
bdmpSetLoginConfig, cappLogin, cappIsLogin, cappSetLoginConfig, cowxmpLogin, cowxmpIsLogin, cowxmpSetLoginConfig, cxwxmpLogin, cxwxmpIsLogin, cxwxmpSetLoginConfig, driverLogin, driverLogout, driverIsLogin, driverSetLoginConfig, drwxmpLogin, drwxmpIsLogin, drwxmpSetLoginConfig, gjwxmpLogin, gjwxmpIsLogin, gjwxmpSetLoginConfig, h5Login, h5Logout, h5IsLogin, h5LoginCheckPhone, h5SetLoginConfig, kfalimpLogin, kfalimpIsLogin, kfalimpSetLoginConfig, kfdriverLogin, kfdriverLogout, kfdriverIsLogin, kfdriverSetLoginConfig, kfdwxmpLogin, kfdwxmpIsLogin, kfdwxmpSetLoginConfig, kfpassengerLogin, kfpassengerIsLogin, kfpassengerSetLoginConfig, kfwxmpLogin, kfwxmpIsLogin, kfwxmpSetLoginConfig, mqqLogin, mqqLogout, mqqIsLogin, mqqLoginCheckPhone, mqqSetLoginConfig, passengerLogin, passengerIsLogin, passengerSetLoginConfig, qjwxmpLogin, qjwxmpIsLogin, qjwxmpSetLoginConfig, 
// qqmpLogin,
qqmpIsLogin, qqmpSetLoginConfig, thwxmpLogin, thwxmpIsLogin, thwxmpSetLoginConfig, weixinLogin, weixinLogout, weixinIsLogin, weixinLoginCheckPhone, weixinSetLoginConfig, wxmpLogin, wxmpIsLogin, wxmpSetLoginConfig, yxwxmpLogin, yxwxmpIsLogin, yxwxmpSetLoginConfig, gaswxmpIsLogin, gaswxmpSetLoginConfig, esappLogin, esappIsLogin, hitchappIsLogin, hitchappLogin, hitchappSetLoginConfig, sfcwxmpLogin, sfcwxmpIsLogin, sfcwxmpSetLoginConfig, hywxmpIsLogin, hywxmpLogin, hywxmpSetLoginConfig, hydriverLogin, hydriverIsLogin, hydriverSetLoginConfig } from '../platform/xenv';
import { updateWebxUserInfo } from '../webx';
const xenvLoginConfig = {
    alimp: alimpLogin,
    alipay: alipayLogin,
    // 'bdmp': bdmpLogin,
    capp: cappLogin,
    cowxmp: cowxmpLogin,
    cxwxmp: cxwxmpLogin,
    sfcwxmp: sfcwxmpLogin,
    driver: driverLogin,
    drwxmp: drwxmpLogin,
    gjwxmp: gjwxmpLogin,
    h5: h5Login,
    kfalimp: kfalimpLogin,
    kfdriver: kfdriverLogin,
    kfdwxmp: kfdwxmpLogin,
    kfpassenger: kfpassengerLogin,
    kfwxmp: kfwxmpLogin,
    mqq: mqqLogin,
    passenger: passengerLogin,
    qjwxmp: qjwxmpLogin,
    // 'qqmp': qqmpLogin,
    thwxmp: thwxmpLogin,
    weixin: weixinLogin,
    wxmp: wxmpLogin,
    yxwxmp: yxwxmpLogin,
    esapp: esappLogin,
    hitchapp: hitchappLogin,
    hywxmp: hywxmpLogin,
    hydriver: hydriverLogin
};
const xenvLogoutConfig = {
    alipay: alipayLogout,
    driver: driverLogout,
    kfdriver: kfdriverLogout,
    h5: h5Logout,
    mqq: mqqLogout,
    weixin: weixinLogout
};
const xenvIsLoginConfig = {
    alimp: alimpIsLogin,
    alipay: alipayIsLogin,
    // 'bdmp': bdmpIsLogin,
    capp: cappIsLogin,
    cowxmp: cowxmpIsLogin,
    cxwxmp: cxwxmpIsLogin,
    sfcwxmp: sfcwxmpIsLogin,
    driver: driverIsLogin,
    drwxmp: drwxmpIsLogin,
    gjwxmp: gjwxmpIsLogin,
    h5: h5IsLogin,
    kfalimp: kfalimpIsLogin,
    kfdriver: kfdriverIsLogin,
    kfdwxmp: kfdwxmpIsLogin,
    kfpassenger: kfpassengerIsLogin,
    kfwxmp: kfwxmpIsLogin,
    mqq: mqqIsLogin,
    passenger: passengerIsLogin,
    qjwxmp: qjwxmpIsLogin,
    qqmp: qqmpIsLogin,
    thwxmp: thwxmpIsLogin,
    weixin: weixinIsLogin,
    wxmp: wxmpIsLogin,
    yxwxmp: yxwxmpIsLogin,
    gaswxmp: gaswxmpIsLogin,
    esapp: esappIsLogin,
    hitchapp: hitchappIsLogin,
    hywxmp: hywxmpIsLogin,
    hydriver: hydriverIsLogin
};
const xenvLoginCheckPhoneConfig = {
    alipay: alipayLoginCheckPhone,
    h5: h5LoginCheckPhone,
    mqq: mqqLoginCheckPhone,
    weixin: weixinLoginCheckPhone
};
const xenvSetLoginConfigConfig = {
    alimp: alimpSetLoginConfig,
    alipay: alipaySetLoginConfig,
    bdmp: bdmpSetLoginConfig,
    capp: cappSetLoginConfig,
    cowxmp: cowxmpSetLoginConfig,
    cxwxmp: cxwxmpSetLoginConfig,
    sfcwxmp: sfcwxmpSetLoginConfig,
    driver: driverSetLoginConfig,
    drwxmp: drwxmpSetLoginConfig,
    gjwxmp: gjwxmpSetLoginConfig,
    h5: h5SetLoginConfig,
    kfalimp: kfalimpSetLoginConfig,
    kfdriver: kfdriverSetLoginConfig,
    kfdwxmp: kfdwxmpSetLoginConfig,
    kfpassenger: kfpassengerSetLoginConfig,
    kfwxmp: kfwxmpSetLoginConfig,
    qjwxmp: qjwxmpSetLoginConfig,
    mqq: mqqSetLoginConfig,
    passenger: passengerSetLoginConfig,
    qqmp: qqmpSetLoginConfig,
    thwxmp: thwxmpSetLoginConfig,
    weixin: weixinSetLoginConfig,
    wxmp: wxmpSetLoginConfig,
    yxwxmp: yxwxmpSetLoginConfig,
    gaswxmp: gaswxmpSetLoginConfig,
    hitchapp: hitchappSetLoginConfig,
    hywxmp: hywxmpSetLoginConfig,
    hydriver: hydriverSetLoginConfig
};
export const login = (opt) => {
    const fn = xenvActionFactory('login', xenvLoginConfig);
    try {
        window.PerfTrack.PrivateMethods.LoginStart();
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
    return fn(opt)
        .then(res => {
        if ('token' in res || 'uid' in res) {
            updateWebxUserInfo({ token: res.token, uid: res.uid }).catch(err => console.warn('=== webx上传用户信息失败 ===', err));
        }
        try {
            window.PerfTrack.PrivateMethods.LoginEnd();
            // eslint-disable-next-line no-empty
        }
        catch (_) { }
        return res;
    })
        .catch(error => {
        try {
            window.PerfTrack.PrivateMethods.LoginEnd();
            // eslint-disable-next-line no-empty
        }
        catch (_) { }
        return Promise.reject(error);
    });
};
export const logout = () => {
    const fn = xenvActionFactory('logout', xenvLogoutConfig);
    return fn();
};
export const isLogin = (opt, callback) => {
    const fn = xenvActionFactory('isLogin', xenvIsLoginConfig);
    try {
        window.PerfTrack.PrivateMethods.LoginCheckStart();
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
    return fn(opt, callback)
        .then(res => {
        if ('token' in res || 'uid' in res) {
            updateWebxUserInfo({ token: res.token, uid: res.uid }).catch(err => console.warn('=== webx上传用户信息失败 ===', err));
        }
        try {
            window.PerfTrack.PrivateMethods.LoginCheckEnd();
            // eslint-disable-next-line no-empty
        }
        catch (_) { }
        return res;
    })
        .catch(error => {
        try {
            window.PerfTrack.PrivateMethods.LoginCheckEnd();
            // eslint-disable-next-line no-empty
        }
        catch (_) { }
        return Promise.reject(error);
    });
};
export const loginCheckPhone = (phone) => {
    const fn = xenvActionFactory('loginCheckPhone', xenvLoginCheckPhoneConfig);
    return fn(phone).then(res => {
        if ('token' in res || 'uid' in res) {
            updateWebxUserInfo({ token: res.token, uid: res.uid }).catch(err => console.warn('=== webx上传用户信息失败 ===', err));
        }
        return res;
    });
};
/**
 * setLoginConfig 设置web登录
 * @param sdkUrl
 * @param offlineSdkUrl
 * @param version
 * @param appid
 * @param role
 * @param lang
 * @param offline
 * @param country_calling_code
 * @param country_id
 * @param loginType
 * @param loginJsVersion
 * @example
 * ```js
 *   setLoginConfig({
 *     offline: true
 *   })
 * ```
 */
export const setLoginConfig = (opt) => {
    const fn = xenvActionFactory('setLoginConfig', xenvSetLoginConfigConfig);
    return fn(opt);
};
